<script setup lang="ts">
  import { type UserAvatarProps, VUserAvatar } from "@krainovsd/vue-ui";
  import { computed, useCssModule } from "vue";

  type Props = Omit<UserAvatarProps, "size"> & { size?: "small" | "big" };

  const props = withDefaults(defineProps<Props>(), { size: "small" });
  const styles = useCssModule();
  const classes = computed(() => ({
    [styles.base]: true,
    [styles.small]: props.size === "small" || props.size == undefined,
    [styles.big]: props.size === "big",
  }));
</script>

<template>
  <VUserAvatar
    :class="classes"
    :name="$props.name"
    :avatar="$props.avatar"
    :initials="$props.initials"
  />
</template>

<style lang="scss" module>
  .base {
    background-color: var(--secondary);
    --ksd-text-main-color: var(--foreground);
  }
  .small {
    --ksd-control-height: 16px;
    --ksd-font-size: 10px;
  }
  .big {
    --ksd-control-height: 5rem;
    --ksd-font-size: 1.5rem;
  }
</style>
